import { Component, OnInit } from '@angular/core';
import { RetornoSelecao } from './../../../shared/gridview/RetornoSelecao';
import { Estado } from './../../../shared/shared/estado.enum';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-produtividade-indice',
  templateUrl: './produtividade-indice.component.html',
  styleUrls: ['./produtividade-indice.component.css']
})
export class ProdutividadeIndiceComponent implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;

  constructor() {

  }

  ngOnInit() {
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {

    this.state = Estado.view;

    this.selecionado = selecionado.registro;
  }
}
